var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 8 19 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.457 23.006c.369.41.369 1.025 0 1.394-.41.41-1.026.41-1.395 0l-4.84-4.88-4.88 4.88c-.41.41-1.026.41-1.395 0-.41-.369-.41-.984 0-1.394l4.88-4.881-4.88-4.88c-.41-.411-.41-1.026 0-1.395a.898.898 0 0 1 1.353 0l4.922 4.922 4.881-4.881a.898.898 0 0 1 1.354 0c.41.369.41.984 0 1.394l-4.881 4.84z"
  })));
};
export default SvgCross;